import React, { useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import { humanizeErrors } from '../../helpers/errorHelper'

const ErrorType = PropTypes.shape({
  submission: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired
})

const DisplayErrors = ({ errors }) => {
  const errorsRef = React.useRef(null)
  const [focus, setFocus] = useState(true)

  const _observerCallback = (entries) => {
    let [entry] = entries
    if (entry.isIntersecting) {
      setTimeout(() => {
        setFocus(false)
      }, 100)
    }
  }

  const intersectionObserver = new IntersectionObserver(_observerCallback)

  useEffect(() => {
    if(!focus) intersectionObserver.disconnect()
  },[focus])

  const _displayErrors = () => {
    let newErrors = humanizeErrors(errors.errors)
    return (
      <React.Fragment>
        <h2 id="submission-errors" ref={errorsRef} className="error">{errors.submission}</h2>
        <ul className="errors">
          { _mapErrors(newErrors) }
        </ul>
      </React.Fragment>
    )
  }

  const _mapErrors = (newErrors) => {
    return newErrors.map((error, i) => {
      return <li key={i} dangerouslySetInnerHTML={{ __html: error }} />
    })
  }

  const _focusOnErrors = () => {
    if(errorsRef && errorsRef.current) {
      let el = errorsRef.current
      // start observing
      intersectionObserver.observe(el)

      el.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }

  return (
    <React.Fragment>
      { _displayErrors() }
      { focus && _focusOnErrors() }
    </React.Fragment>
  )
}

DisplayErrors.propTypes = {
  errors: ErrorType.isRequired
}

export default DisplayErrors
